export default __webpack_public_path__ + "static/media/Background 5_00029.d190e547.png";